<div class="tw-w-full tw-h-full" resizeObserver (resizeEvent)="onResize()">
  <div #templateEditorPreviewParent class="presentation-preview-parent preview-parent embed-responsive">
    <iframe #templateEditorPreview [id]="productCode ? 'preview-' + productCode : 'presentation'"
      class="presentation-preview embed-responsive-item"
      scrolling="no"
      [src]="editorPreviewUrl" (load)="onLoad($event)">
    </iframe>
  </div>
</div>